import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CircleAboutRoute extends DiscourseRoute {
  showFooter = true;

  titleToken() {
    return i18n("discourse_circles.circle.about.title_token", {
      circle_name: this.modelFor("circle").name,
    });
  }

  model() {
    return this.modelFor("circle");
  }
}
